import feuille from "../../../assets/images/feuille.svg";
import eau from "../../../assets/images/eau.svg";
import pierre from "../../../assets/images/pierre.svg";
import soleil from "../../../assets/images/soleil.svg";

export const nosValeurs = [
  {
    title: "Professionnalisme & Innovation ",
    text: "<p>Des projets sur mesure, adaptés à vos besoins & des matériaux de qualité assemblés avec soin. En tant qu&apos;artisan présent depuis 1978, nous avons su évoluer pour vous proposer de nouveaux matériaux tout en gardant à l’esprit la pérennité de nos réalisations. </p>",
    icon: soleil,
  },
  {
    title: "Honnêteté & Transparence",
    text: "<p>Écoute, accompagnement, conseil... Concevoir un projet durable, c’est le construire ensemble en tenant compte de vos souhaits, de vos envies, des caractéristiques du terrain... Nous sommes là pour vous conseiller du mieux que nous le pouvons.</p>",
    icon: feuille,
  },
  {
    title: "Humaine & Collaborative",
    text: `<p>Une équipe impliquée avec le goût du travail bien fait.<br />
    Chacun a son rôle à jouer et participe à la réussite collective. Ensemble, on fait tellement plus de choses !</p>`,
    icon: eau,
  },
  {
    title: "Amélioration continue & Développement durable",
    text: `<p>Faire plus avec moins ? L‘efficience !
              C’est bon pour l’environnement et la santé !
              Nous cherchons toujours à optimiser les process afin de réduire, et notre impact sur la planète, et la fatigue des équipes !</p>`,
    icon: pierre,
  },
];

export const teamMembers = [
  {
    fullName: "Karine",
    text: "<p>Assistante de direction <br/> Trait de caractère principal : Une main de fer dans un gant de velours</p>",
  },
  {
    fullName: "Laure",
    text: "<p>Bureau d’ étude <br/> Trait de caractère principal : Tant qu’elle sourit tout va bien</p>",
  },
  {
    fullName: "Thomas",
    text: "<p>Responsable création <br/> Trait de caractère principal : Il faut que tout roule ( le vélo aussi ) </p>",
  },
  {
    fullName: "Charles",
    text: "<p>Gérant <br/>Trait de caractère principal : Sérieux mais pas trop</p>",
  },
  {
    fullName: "Ludovic",
    text: "<p>Compagnon d’ entretien <br/> Trait de caractère principal : Calme & organisé</p>",
  },
  {
    fullName: "Alain",
    text: "<p> Compagnon d’ entretien <br/> Trait de caractère principal : Ca va toujours&nbsp;!</p>",
  },
  {
    fullName: "Kevin",
    text: "<p> Compagnon de création Trait de caractère principal : Le devoir l’appel </p>",
  },
  {
    fullName: "Geoffrey",
    text: "<p>Compagnon de création <br/>Trait de caractère principal : Progresser progresser progresser </p>",
  },
  {
    fullName: "Mickael",
    text: "<p>Chef d’équipe entretien<br/> Trait de caractère principal : Il faut que tout soit nickel</p>",
  },
  {
    fullName: "Tom",
    text: "<p>Jeune pousse en création <br/>Trait de caractère principal : Toujours partant</p>",
  },
  {
    fullName: "Maxime",
    text: "<p>Compagnon d’ entretien <br/>Trait de caractère principal : A envie d’apprendre et de progresser </p>",
  },
  {
    fullName: "Willy",
    text: "<p>Jeune pousse en création <br/>Trait de caractère principal : Curieux et volontaire </p>",
  },
  {
    fullName: "Bruno",
    text: "<p>Chef d’équipe création <br/>Trait de caractère principal : Quand le camion va, tout va ! </p>",
  },
  {
    fullName: "Franck",
    text: "<p>Chef d’équipe création <br/>Trait de caractère principal : Le travail c’est la santé</p>",
  },
  {
    fullName: "Hervé",
    text: "<p>Chef d’équipe création <br/>Trait de caractère principal : Bien travailler en rigolant c’ est la base</p>",
  },
  {
    fullName: "Jacques",
    text: "<p>Responsable entretien <br/>Trait de caractère principal : Aime raler mais véritable pilier</p>",
  },
  {
    fullName: "Morgan",
    text: "<p> Chef d'équipe entretien <br/> Trait de caractère principal : Travail soigné dans la bonne humeur </p>",
  },
  {
    fullName: "Clémentine",
    text: "<p>Jeune pousse en entretien <br/>Trait de caractère principal : Discrète mais efficace</p>",
  },
  {
    fullName: "Clément",
    text: "<p>Compagnon de création <br/>Trait de caractère principal : L’ envie de bien faire</p>",
  },
  {
    fullName: "Tom le chat",
    text: "<p>Mascotte féline <br/>Trait de caractère principal : Manger, ManGER, MAAAAAANGER</p>",
    extension: ".png",
  },
  {
    fullName: "Tally",
    text: "<p>Mascotte canine <br/>Trait de caractère principal : Adoooooooore les calins </p>",
  },
].map((el) => ({
  ...el,
  img: `/images/avatars/${el.fullName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()}${el.extension ? el.extension : ".svg"}`,
  mock: false,
}));
